import gsap from 'gsap'

export const preloader = () => {

	let el = document.querySelector('[data-animation="preloader"]')

	if (!el) return

	let logo = el.querySelector('[data-el="logo"]'),
		logotype = el.querySelector('[data-el="logotype"]')

	logo.style.opacity = 1

	gsap.set(logo, {
		transformOrigin: '5% 50%',
	})

	gsap.fromTo(logo, {
		opacity: 0,
	}, {
		opacity: 1,
		duration: 0.4,
	})

	gsap.fromTo(logo, {
		x: '44%',
	}, {
		x: 0,
		duration: 1,
		delay: 0.2,
		ease: 'power2.out',
	})

	gsap.fromTo(logotype, {
		x: '-100%',
	}, {
		x: 0,
		duration: 1,
		delay: 0.2,
		ease: 'power2.out',
	})
}

export default () => { }